import { captureException } from '@sentry/react';

export function logError(err: unknown) {
  captureException(err);
}
